import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

export function CTASection() {
  return (
    <section className="py-24 lg:py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-3xl bg-wine-gradient p-12 lg:p-20 text-center overflow-hidden"
        >
          {/* Decorative elements */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10">
            <div className="absolute top-10 left-10 w-32 h-32 border border-white rounded-full" />
            <div className="absolute bottom-10 right-10 w-48 h-48 border border-white rounded-full" />
            <div className="absolute top-1/2 left-1/4 w-20 h-20 border border-white rounded-full" />
          </div>

          <div className="relative z-10 max-w-3xl mx-auto space-y-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/20 text-white text-sm font-medium backdrop-blur-sm"
            >
              <Sparkles size={16} />
              Comece gratuitamente
            </motion.div>

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight"
            >
              Pronto para transformar seus eventos em sucesso?
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="text-white/80 text-lg lg:text-xl"
            >
              Crie sua conta gratuita agora e comece a vender ingressos hoje mesmo.
              Sem custos de adesão, pague apenas quando vender.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.5 }}
              className="flex flex-col sm:flex-row gap-4 justify-center"
            >
              <Link to="/criar-conta">
                <Button 
                  variant="gold" 
                  size="xl" 
                  className="group w-full sm:w-auto text-foreground"
                >
                  Criar conta grátis
                  <ArrowRight className="group-hover:translate-x-1 transition-transform" size={18} />
                </Button>
              </Link>
              <Link to="/contato">
                <Button variant="heroOutline" size="xl" className="w-full sm:w-auto">
                  Falar com vendas
                </Button>
              </Link>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
